import React from 'react';
import { Field } from 'redux-form';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div className="form-group">
    <label>{label}</label>
    <div>
      <input className="form-control" {...input} type={type} placeholder={label}/>
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);


export const GeneralContactInput = () => {
  return (
    <div>
      <div className="form-group">
        <label>Type</label>
        <div>
          <Field
            className="form-control"
            name="contact_type"
            component="select">
            <option>--</option>
            <option value="envelope">Email</option>
            <option value="mobile">Mobile</option>
          </Field>
        </div>
      </div>

      <Field
        name="contact"
        type="text"
        component={renderField}
        label="Value"/>
    </div>
  );
};

export const SocialContactInput = () => {
  return (
    <div>
      <div className="form-group">
        <label>Type</label>
        <div>
          <Field
            className="form-control"
            name="contact_type"
            component="select">
            <option>--</option>
            <option value="facebook">Facebook</option>
            <option value="instagram">Instagram</option>
          </Field>
        </div>
      </div>

      <Field
        name="contact"
        type="text"
        component={renderField}
        label="Contact"/>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/contacts/Contacts.js